import { useMemo } from "react";
import { Cart, CartPricing } from "../types/Cart";

const PricingTiers = [
  {
    lineItemMin: 0,
    lineItemMax: 50,
    priceX100: 5 * 100,
    stripePaymentLink: "https://buy.stripe.com/5kQ00jdvw1gAdg88nj5kk0q",
  },
  {
    lineItemMin: 51,
    lineItemMax: 250,
    priceX100: 15 * 100,
    stripePaymentLink: "https://buy.stripe.com/fZu14ndvw6AUa3W6fb5kk0r",
  },
  {
    lineItemMin: 251,
    lineItemMax: 1000,
    priceX100: 25 * 100,
    stripePaymentLink: "https://buy.stripe.com/00w4gz1MO8J25NG8nj5kk0s",
  },
  {
    lineItemMin: 1001,
    lineItemMax: 2500,
    priceX100: 50 * 100,
    stripePaymentLink: "https://buy.stripe.com/eVqbJ1778gbu1xqavr5kk0t",
  },
];

export function useCartPricing(cart: Cart | null): CartPricing {
  return useMemo(() => {
    const lineItemCount = cart?.items.length ?? 0;

    const tier = PricingTiers.find((tier) => {
      return (
        lineItemCount >= tier.lineItemMin && lineItemCount <= tier.lineItemMax
      );
    });

    if (!tier) {
      throw new Error("No tier found for line item count");
    }

    return {
      tierDescription: `${tier.lineItemMin}-${tier.lineItemMax} contacts`,
      totalX100: tier.priceX100,
      lineItemCount,
      stripePaymentLink: tier.stripePaymentLink,
    };
  }, [cart]);
}
